import React from "react";

const TopHeader = () => {
    return (
        <div id="topnavbar"
             style={{width: "100%", height: "25px", borderBottom: "1px solid  #E6E6E6"}}>
            <div id="bar">
                <div id="container">
                    <table width="100%" border="0"  >
                        <tbody>
                        <tr>
                            <td><strong>Xổ Số Minh Ngọc™ » XSMN » Kết quả xổ số trực tiếp » Đổi Số
                                Trúng »
                                www.minhngoc.website</strong></td>
                            <td align="right" style={{height: "25px"}}>
                                <div id="user_form">
                                    <div>
                                        <form id="loginForm" name="loginForm">
                                            {/*@csrf*/}
                                            <table border="0"
                                                   align="right">
                                                <tbody>
                                                <tr>
                                                    <td>
                                                        <div id="msgbox"/>
                                                    </td>
                                                    <td><a href="/" title="Đăng ký thành viên">Đăng
                                                        ký</a></td>
                                                    <td>Đăng nhập</td>
                                                    <td><input type="text" name="username"
                                                               id="username"
                                                               style={{width: "100px"}}
                                                               defaultValue="Tên đăng nhập"
                                                               onFocus={() => {
                                                                   if (this.value === 'Tên đăng nhập') this.value = ''
                                                               }}
                                                               onMouseOut={() => {
                                                                   if (this.value === '') this.value = 'Tên đăng nhập'
                                                               }}
                                                    />
                                                    </td>
                                                    <td>
                                                        <input type="text" name="passwords"
                                                               id="passwords"
                                                               style={{width: "100px"}}
                                                               defaultValue="Password"
                                                               onFocus={() => {
                                                                   document.getElementById("passwords").show();
                                                                   document.getElementById("passwords").focus();
                                                                   (this).hide()
                                                               }}/>
                                                        <input type="current-password"
                                                               name="password"
                                                               id="password"
                                                               style={{
                                                                   width: "100px",
                                                                   display: "none"
                                                               }}/></td>
                                                    <td><label htmlFor="checkbox"><input
                                                        type="checkbox" id="cookieuser"
                                                        name="cookieuser" defaultValue="1"/>Ghi
                                                        nhớ</label></td>
                                                    <td><input name="Submit" type="submit"
                                                               id="login" value="Login"/>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </form>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};
export default TopHeader
